import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { NavLink } from "react-router-dom";

const ComponentHeader = ({ url, first_string_color, second_string_color, view_all, second_title,title, first_title }) => {
    return (
        <div className="component_header">
            <div >
                <h4>{title}</h4>
            </div>
            {
                url != undefined &&
                <NavLink className="text-decoration-none view_all" to={url}>
                    <div className="link" >View all</div>
                    <div className="link_icon" >
                        <BsArrowRight color="#43494B" size={20} />
                    </div>
                </NavLink>
            }
        </div>
    )
}
export default ComponentHeader;